<template>
  <CRow>
    <!-- 🔹 MODAL -->
    <CModal
      title="Update Bank Status"
      size="lg"
      :show.sync="largeModal"
      :no-close-on-backdrop="true"
      color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>

      <CForm @submit.prevent="onSubmit">
        <CCardBody>
          <!-- 🔹 VIEW DETAILS -->
          <div class="row">

            <div class="col-md-6">
              <label><b>User Name:</b></label>
              <p>{{ bankDetails.created }}</p>
            </div>
             <div class="col-md-6">
              <label><b>Company Name:</b></label>
              <p>{{ bankDetails.company }}</p>
            </div>
            <div class="col-md-6">
              <label><b>Bank Name:</b></label>
              <p>{{ bankDetails.name }}</p>
            </div>

            <div class="col-md-6">
              <label><b>Account Holder:</b></label>
              <p>{{ bankDetails.accountHolderName }}</p>
            </div>

            <div class="col-md-6">
              <label><b>Account Number:</b></label>
              <p>{{ bankDetails.accountNumber }}</p>
            </div>

            <div class="col-md-6">
              <label><b>IFSC Code:</b></label>
              <p>{{ bankDetails.ifscCode }}</p>
            </div>

            <div class="col-md-6">
              <label><b>Address:</b></label>
              <p>{{ bankDetails.address }}</p>
            </div>

          </div>

          <!-- 🔹 IMAGE PREVIEW (if exists) -->
          <div v-if="bankDetails.images && bankDetails.images.length" class="mt-3">
          <label><b>Documents:</b></label><br />

          <div
            v-for="img in bankDetails.images"
            :key="img.id"
            class="mb-2"
          >
            <p><b><a :href="img.url" target="_blank" rel="noopener noreferrer">
              {{ img.media }}
            </a></b></p>
          </div>
        </div>

          <hr />

          <!-- 🔹 STATUS -->
          <div class="form-group" v-if="bankDetails.status == 0">
          <label>Status</label><br />

          <div class="form-check form-check-inline">
            <input
              type="radio"
              id="bankStatusApprove"
              class="form-check-input"
              :value="1"
              v-model.number="bank.isActive"
            />
            <label class="form-check-label" for="bankStatusApprove">Approve</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              id="bankStatusReject"
              class="form-check-input"
              :value="0"
              v-model.number="bank.isActive"
            />
            <label class="form-check-label" for="bankStatusReject">Reject</label>
          </div>
        </div>

        <!-- Show remark only when rejected -->
        <div class="form-group" v-if="bankDetails.status == 0 && bank.isActive === 0">
          <label>
            Remark <span class="text-danger">*</span>
          </label>

          <input
            class="form-control"
            v-model="bank.remark"
            placeholder="Enter remark"
            :required="bank.isActive === 0"
          />
        </div>

          </CCardBody>

        <CCardFooter>
          <CButton type="submit" size="sm" color="primary" :disabled="submitted"  v-if="bankDetails.status == 0">
            <CIcon name="cil-check-circle" />
            Submit
          </CButton>
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>

    <!-- 🔹 TABLE -->
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <strong>Bank List</strong>
        </CCardHeader>

        <CCardBody>
          <CAlert color="success" closeButton :show.sync="dismissCountDownS" fade>
            {{ alertMessage }}
          </CAlert>

          <v-server-table
            :columns="columns"
            url="/bank/list"
            :options="options"
            ref="myTable"
          >

            <!-- Status -->
            <template #status="data">
              <CBadge :color="getStatusColor(data.row.status)">
                {{ getStatusText(data.row.status) }}
              </CBadge>
            </template>

            <!-- Actions -->
            <template #actions="data">
              <CButton
                color="success"
                @click="editTableRow(data.row.id)"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
            </template>

          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import { ServerTable } from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import VueToasted from "vue-toasted";
import axios from "axios";
import store from "@/store/store";

Vue.use(ServerTable, {}, false);
Vue.use(VueSweetalert2);
Vue.use(VueToasted);

export default {
  name: "BankStatus",

  data() {
    return {
      largeModal: false,
      submitted: false,
      err_msg: "",
      alertMessage: "",
      dismissCountDown: 0,
      dismissCountDownS: 0,
      editId: null,
      bank: {
        isActive: 1,
        remark: "",
      },
      bankDetails: {
        name: "",
        companyName: "",
        accountHolderName: "",
        accountNumber: "",
        ifscCode: "",
        address: "",
        images: "",
        company : "",
        created : "",
        status:""
      },
      columns: ["name", "accountHolderName","accountNumber","companyName", "status", "actions"],
      options: {
        headings: {
          name: "Bank Name",
          accountHolderName: "Account Holder",
          accountNumber: "Account Number",
          companyName: "Company Name",
          status: "Status",
          actions: "Actions",
        },
        sortable: ["name"],
        filterable: ["name"],
      },
    };
  },
  mounted() {
    store.commit('showLoader', false);
  },

  methods: {
    getStatusText(status) {
      if (status == 1) return "Verified";
      if (status == 2) return "Rejected";
      return "Pending";
    },

    getStatusColor(status) {
      if (status == 1) return "success";   // green
      if (status == 2) return "danger";    // red
      return "warning";                   // yellow
    },
    // 🔹 Open modal (Edit)
    editTableRow(id) {
      this.editId = id;
      let self = this;
      axios.get(`/bank/${id}`).then((response) => {
        let data = response.data.data;
        self.bankDetails.name = data.name;
        self.bankDetails.company = data.company_name;
        self.bankDetails.created = data.created_name;
        self.bankDetails.accountHolderName = data.account_holder_name;
        self.bankDetails.accountNumber = data.account_number;
        self.bankDetails.ifscCode = data.ifsc_code;
        self.bankDetails.address = data.address;
        self.bankDetails.status = data.status;
        self.bankDetails.images = data.media;
        // Default to Approve; Reject must be chosen explicitly
        this.bank.isActive = 1;
        this.bank.remark = data.remark || "";
        this.err_msg = "";
        this.dismissCountDown = 0;

        this.largeModal = true;
      });
    },

    // 🔹 Submit update
    onSubmit() {
      let self = this;
      self.submitted = true;

      const postData = {
        isActive: self.bank.isActive,
        // Remark only applies to a rejection
        remark: self.bank.isActive === 0 ? self.bank.remark : "",
      };

      axios
        .post(`/bank/${self.editId}`, postData)
        .then(function (response) {
          self.submitted = false;

          if (response.data) {
            self.alertMessage = response.data.message;
            self.dismissCountDownS = 10;
            self.largeModal = false;
            self.$refs.myTable.refresh();
          } else {
            self.err_msg = response.data.message;
            self.dismissCountDown = 10;
          }
        })
        .catch(function (error) {
          self.err_msg =
            error.response?.data?.message || "Something went wrong";
          self.dismissCountDown = 10;
          self.submitted = false;
        });
    },
  },
};
</script>